module.exports = __webpack_public_path__ + "img/about.f410d91.png";